module.exports = __webpack_public_path__ + "static/media/user.d291cb4f.png";